export enum SpriteType {
  SKIN = 'skin',
  HAIR = 'hair',
  SHIRT = 'shirt',
  PANTS = 'pants',
  SHOES = 'shoes',
  HAT = 'hat',
  ACCESSORY = 'accessory',
  BAG = 'bag',
  BALL = 'ball'
}

export enum BodyType {
  MALE = 'm', // Masculino
  FEMALE = 'f' // Feminino
}

export interface SpriteItem {
  color?: string; // Cor em formato hexadecimal
  colorName?: string; 
  urlSprite?: string; 
}

export interface Sprite {
  body?: BodyType[] | string[];
  name?: string; 
  type?: SpriteType | string;
  items?: SpriteItem[]
}

export interface Avatar {
  body?: BodyType;
  skin?: SpriteItem;
  hair?: SpriteItem;
  shirt?: SpriteItem;
  pants?: SpriteItem;
  shoes?: SpriteItem;
  hat?: SpriteItem;
  accessory?: SpriteItem;
  bag?: SpriteItem;
  ball?: SpriteItem;
}
